export const services = [
  {
    id: 1,
    title: '婚禮花藝設計',
    description: '為您的特別日子打造夢幻花藝佈置，從新娘捧花到會場裝飾，每個細節都展現法式優雅與浪漫',
    icon: 'ri-heart-3-line',
    features: [
      '新娘捧花與伴娘花束設計',
      '婚禮會場花藝佈置',
      '餐桌中心花藝裝飾',
      '迎賓區與背板花藝設計'
    ],
    image: 'https://public.readdy.ai/ai/img_res/994abd443026efc363f173b0325e95f0.jpg'
  },
  {
    id: 2,
    title: '企業活動佈置',
    description: '專業的商業活動花藝服務，提升品牌形象與活動質感，打造令人印象深刻的視覺體驗',
    icon: 'ri-building-line',
    features: [
      '開幕典禮花藝佈置',
      '企業年會場地裝飾',
      '商務會議桌花設計',
      '品牌活動客製化花藝'
    ],
    image: 'https://readdy.ai/api/search-image?query=professional%20corporate%20event%20floral%20decoration%2C%20elegant%20business%20venue%20with%20premium%20flower%20arrangements%2C%20modern%20sophisticated%20style%2C%20luxury%20hotel%20setting%2C%20high-end%20florist%20design%2C%20impressive%20visual%20presentation&width=800&height=600&seq=monceau-corporate-service&orientation=landscape'
  },
  {
    id: 3,
    title: '花藝訂閱服務',
    description: '定期為您的空間注入新鮮活力，每週或每月配送精心挑選的季節花卉，讓生活充滿美好',
    icon: 'ri-calendar-check-line',
    features: [
      '每週或每月定期配送',
      '季節性花材精選',
      '彈性調整配送時間',
      '專屬花藝師設計'
    ],
    image: 'https://readdy.ai/api/search-image?query=fresh%20seasonal%20flowers%20subscription%20service%2C%20elegant%20flower%20delivery%20box%20with%20premium%20blooms%2C%20modern%20lifestyle%20setting%2C%20luxury%20florist%20packaging%2C%20beautiful%20home%20decoration%2C%20sophisticated%20floral%20arrangement&width=800&height=600&seq=monceau-subscription-service&orientation=landscape'
  }
];
